export const Country = [
  { value: "Albania", label: "AL" },
  { value: "Åland Islands", label: "AX" },
  { value: "Algeria", label: "DZ" },
  { value: "American Samoa", label: "AS" },
  { value: "Andorra", label: "AD" },
  { value: "Angola", label: "AO" },
  { value: "Anguilla", label: "AI" },
  { value: "Antarctica", label: "AQ" },
  { value: "Antigua and Barbuda", label: "AG" },
  { value: "Argentina", label: "AR" },
  { value: "Armenia", label: "AM" },
  { value: "Aruba", label: "AW" },
  { value: "Australia", label: "AU" },
  { value: "Austria", label: "AT" },
  { value: "Azerbaijan", label: "AZ" },
  { value: "Bahamas (the)", label: "BS" },
  { value: "Bahrain", label: "BH" },
  { value: "Bangladesh", label: "BD" },
  { value: "Barbados", label: "BB" },
  { value: "Belarus", label: "BY" },
  { value: "Belgium", label: "BE" },
  { value: "Belize", label: "BZ" },
  { value: "Benin", label: "BJ" },
  { value: "Bermuda", label: "BM" },
  { value: "Bhutan", label: "BT" },
  { value: "Bolivia (Plurinational State of)", label: "BO" },
  { value: "Bonaire, Sint Eustatius and Saba", label: "BQ" },
  { value: "Bosnia and Herzegovina", label: "BA" },
  { value: "Botswana", label: "BW" },
  { value: "Bouvet Island", label: "BV" },
  { value: "Brazil", label: "BR" },
  { value: "British Indian Ocean Territory (the)", label: "IO" },
  { value: "Brunei Darussalam", label: "BN" },
  { value: "Bulgaria", label: "BG" },
  { value: "Burkina Faso", label: "BF" },
  { value: "Burundi", label: "BI" },
  { value: "Cabo Verde", label: "CV" },
  { value: "Cambodia", label: "KH" },
  { value: "Cameroon", label: "CM" },
  { value: "Canada", label: "CA" },
  { value: "Cayman Islands (the)", label: "KY" },
  { value: "Central African Republic (the)", label: "CF" },
  { value: "Chad", label: "TD" },
  { value: "Chile", label: "CL" },
  { value: "China", label: "CN" },
  { value: "Christmas Island", label: "CX" },
  { value: "Cocos (Keeling) Islands (the)", label: "CC" },
  { value: "Colombia", label: "CO" },
  { value: "Comoros (the)", label: "KM" },
  { value: "Congo (the Democratic Republic of the)", label: "CD" },
  { value: "Congo (the)", label: "CG" },
  { value: "Cook Islands (the)", label: "CK" },
  { value: "Costa Rica", label: "CR" },
  { value: "Croatia", label: "HR" },
  { value: "Cuba", label: "CU" },
  { value: "Curaçao", label: "CW" },
  { value: "Cyprus", label: "CY" },
  { value: "Czechia", label: "CZ" },
  { value: "Côte d'Ivoire", label: "CI" },
  { value: "Denmark", label: "DK" },
  { value: "Djibouti", label: "DJ" },
  { value: "Dominica", label: "DM" },
  { value: "Dominican Republic (the)", label: "DO" },
  { value: "Ecuador", label: "EC" },
  { value: "Egypt", label: "EG" },
  { value: "El Salvador", label: "SV" },
  { value: "Equatorial Guinea", label: "GQ" },
  { value: "Eritrea", label: "ER" },
  { value: "Estonia", label: "EE" },
  { value: "Eswatini", label: "SZ" },
  { value: "Ethiopia", label: "ET" },
  { value: "Falkland Islands (the) [Malvinas]", label: "FK" },
  { value: "Faroe Islands (the)", label: "FO" },
  { value: "Fiji", label: "FJ" },
  { value: "Finland", label: "FI" },
  { value: "France", label: "FR" },
  { value: "French Guiana", label: "GF" },
  { value: "French Polynesia", label: "PF" },
  { value: "French Southern Territories (the)", label: "TF" },
  { value: "Gabon", label: "GA" },
  { value: "Gambia (the)", label: "GM" },
  { value: "Georgia", label: "GE" },
  { value: "Germany", label: "DE" },
  { value: "Ghana", label: "GH" },
  { value: "Gibraltar", label: "GI" },
  { value: "Greece", label: "GR" },
  { value: "Greenland", label: "GL" },
  { value: "Grenada", label: "GD" },
  { value: "Guadeloupe", label: "GP" },
  { value: "Guam", label: "GU" },
  { value: "Guatemala", label: "GT" },
  { value: "Guernsey", label: "GG" },
  { value: "Guinea", label: "GN" },
  { value: "Guinea-Bissau", label: "GW" },
  { value: "Guyana", label: "GY" },
  { value: "Haiti", label: "HT" },
  { value: "Heard Island and McDonald Islands", label: "HM" },
  { value: "Holy See (the)", label: "VA" },
  { value: "Honduras", label: "HN" },
  { value: "Hong Kong", label: "HK" },
  { value: "Hungary", label: "HU" },
  { value: "Iceland", label: "IS" },
  { value: "India", label: "IN" },
  { value: "Indonesia", label: "ID" },
  { value: "Iran (Islamic Republic of)", label: "IR" },
  { value: "Iraq", label: "IQ" },
  { value: "Ireland", label: "IE" },
  { value: "Isle of Man", label: "IM" },
  { value: "Israel", label: "IL" },
  { value: "Italy", label: "IT" },
  { value: "Jamaica", label: "JM" },
  { value: "Japan", label: "JP" },
  { value: "Jersey", label: "JE" },
  { value: "Jordan", label: "JO" },
  { value: "Kazakhstan", label: "KZ" },
  { value: "Kenya", label: "KE" },
  { value: "Kiribati", label: "KI" },
  { value: "Korea (the Democratic People's Republic of)", label: "KP" },
  { value: "Korea (the Republic of)", label: "KR" },
  { value: "Kuwait", label: "KW" },
  { value: "Kyrgyzstan", label: "KG" },
  { value: "Lao People's Democratic Republic (the)", label: "LA" },
  { value: "Latvia", label: "LV" },
  { value: "Lebanon", label: "LB" },
  { value: "Lesotho", label: "LS" },
  { value: "Liberia", label: "LR" },
  { value: "Libya", label: "LY" },
  { value: "Liechtenstein", label: "LI" },
  { value: "Lithuania", label: "LT" },
  { value: "Luxembourg", label: "LU" },
  { value: "Macao", label: "MO" },
  { value: "Madagascar", label: "MG" },
  { value: "Malawi", label: "MW" },
  { value: "Malaysia", label: "MY" },
  { value: "Maldives", label: "MV" },
  { value: "Mali", label: "ML" },
  { value: "Malta", label: "MT" },
  { value: "Marshall Islands (the)", label: "MH" },
  { value: "Martinique", label: "MQ" },
  { value: "Mauritania", label: "MR" },
  { value: "Mauritius", label: "MU" },
  { value: "Mayotte", label: "YT" },
  { value: "Mexico", label: "MX" },
  { value: "Micronesia (Federated States of)", label: "FM" },
  { value: "Moldova (the Republic of)", label: "MD" },
  { value: "Monaco", label: "MC" },
  { value: "Mongolia", label: "MN" },
  { value: "Montenegro", label: "ME" },
  { value: "Montserrat", label: "MS" },
  { value: "Morocco", label: "MA" },
  { value: "Mozambique", label: "MZ" },
  { value: "Myanmar", label: "MM" },
  { value: "Namibia", label: "NA" },
  { value: "Nauru", label: "NR" },
  { value: "Nepal", label: "NP" },
  { value: "Netherlands (the)", label: "NL" },
  { value: "New Caledonia", label: "NC" },
  { value: "New Zealand", label: "NZ" },
  { value: "Nicaragua", label: "NI" },
  { value: "Niger (the)", label: "NE" },
  { value: "Nigeria", label: "NG" },
  { value: "Niue", label: "NU" },
  { value: "Norfolk Island", label: "NF" },
  { value: "Northern Mariana Islands (the)", label: "MP" },
  { value: "Norway", label: "NO" },
  { value: "Oman", label: "OM" },
  { value: "Pakistan", label: "PK" },
  { value: "Palau", label: "PW" },
  { value: "Palestine, State of", label: "PS" },
  { value: "Panama", label: "PA" },
  { value: "Papua New Guinea", label: "PG" },
  { value: "Paraguay", label: "PY" },
  { value: "Peru", label: "PE" },
  { value: "Philippines (the)", label: "PH" },
  { value: "Pitcairn", label: "PN" },
  { value: "Poland", label: "PL" },
  { value: "Portugal", label: "PT" },
  { value: "Puerto Rico", label: "PR" },
  { value: "Qatar", label: "QA" },
  { value: "Republic of North Macedonia", label: "MK" },
  { value: "Romania", label: "RO" },
  { value: "Russian Federation (the)", label: "RU" },
  { value: "Rwanda", label: "RW" },
  { value: "Réunion", label: "RE" },
  { value: "Saint Barthélemy", label: "BL" },
  { value: "Saint Helena, Ascension and Tristan da Cunha", label: "SH" },
  { value: "Saint Kitts and Nevis", label: "KN" },
  { value: "Saint Lucia", label: "LC" },
  { value: "Saint Martin (French part)", label: "MF" },
  { value: "Saint Pierre and Miquelon", label: "PM" },
  { value: "Saint Vincent and the Grenadines", label: "VC" },
  { value: "Samoa", label: "WS" },
  { value: "San Marino", label: "SM" },
  { value: "Sao Tome and Principe", label: "ST" },
  { value: "Saudi Arabia", label: "SA" },
  { value: "Senegal", label: "SN" },
  { value: "Serbia", label: "RS" },
  { value: "Seychelles", label: "SC" },
  { value: "Sierra Leone", label: "SL" },
  { value: "Singapore", label: "SG" },
  { value: "Sint Maarten (Dutch part)", label: "SX" },
  { value: "Slovakia", label: "SK" },
  { value: "Slovenia", label: "SI" },
  { value: "Solomon Islands", label: "SB" },
  { value: "Somalia", label: "SO" },
  { value: "South Africa", label: "ZA" },
  { value: "South Georgia and the South Sandwich Islands", label: "GS" },
  { value: "South Sudan", label: "SS" },
  { value: "Spain", label: "ES" },
  { value: "Sri Lanka", label: "LK" },
  { value: "Sudan (the)", label: "SD" },
  { value: "Suriname", label: "SR" },
  { value: "Svalbard and Jan Mayen", label: "SJ" },
  { value: "Sweden", label: "SE" },
  { value: "Switzerland", label: "CH" },
  { value: "Syrian Arab Republic", label: "SY" },
  { value: "Taiwan (Province of China)", label: "TW" },
  { value: "Tajikistan", label: "TJ" },
  { value: "Tanzania, United Republic of", label: "TZ" },
  { value: "Thailand", label: "TH" },
  { value: "Timor-Leste", label: "TL" },
  { value: "Togo", label: "TG" },
  { value: "Tokelau", label: "TK" },
  { value: "Tonga", label: "TO" },
  { value: "Trinidad and Tobago", label: "TT" },
  { value: "Tunisia", label: "TN" },
  { value: "Turkey", label: "TR" },
  { value: "Turkmenistan", label: "TM" },
  { value: "Turks and Caicos Islands (the)", label: "TC" },
  { value: "Tuvalu", label: "TV" },
  { value: "Uganda", label: "UG" },
  { value: "Ukraine", label: "UA" },
  { value: "United Arab Emirates (the)", label: "AE" },
  {
    value: "United Kingdom of Great Britain and Northern Ireland (the)",
    label: "GB",
  },
  { value: "United States Minor Outlying Islands (the)", label: "UM" },
  { value: "United States of America (the)", label: "US" },
  { value: "Uruguay", label: "UY" },
  { value: "Uzbekistan", label: "UZ" },
  { value: "Vanuatu", label: "VU" },
  { value: "Venezuela (Bolivarian Republic of)", label: "VE" },
  { value: "Viet Nam", label: "VN" },
  { value: "Virgin Islands (British)", label: "VG" },
  { value: "Virgin Islands (U.S.)", label: "VI" },
  { value: "Wallis and Futuna", label: "WF" },
  { value: "Western Sahara", label: "EH" },
  { value: "Yemen", label: "YE" },
  { value: "Zambia", label: "ZM" },
  { value: "Zimbabwe", label: "ZW" },
];
